import React from "react";
import "./ContactPageDash.css";
import ContactTableDash from "../../components/ContactTableDash/ContactTableDash";
import TableContactPopUp from "../../components/TableContactPopUp/TableContactPopUp";
import TableContactInsurance from "../../components/TableContactInsurance/TableContactInsurance";
import Yad2ContactLeadsTable from "../../components/Yad2ContactLeadsTable/Yad2ContactLeadsTable";
import AutoProCostumersTableDash from "../../components/AutoProCostumersTableDash/AutoProCostumersTableDash";
import { Link } from "react-router-dom"; // ✅ הוספת הייבוא

const ContactPageDash = () => {
  return (
    <div>
                  <div className="ButtonToDash-Button">
                    <Link to="/dashboard">
                      <button className="ButtonToDashbord">מעבר לדשבורד</button>
                    </Link>
                  </div>
        <h1 className="ContactPageDashh1">עמוד נתונים לקוחות יצירת קשר</h1>
        <ContactTableDash />
        <TableContactPopUp />
        <TableContactInsurance />
        <Yad2ContactLeadsTable />
        <AutoProCostumersTableDash />
    </div>
  );
};

export default ContactPageDash;